// @flow
import { connect } from 'react-redux'
import Carousel from './Carousel'
import { patch, add } from '../../redux/ducks/carouselEdit/reducers'
import type { Store } from '../../redux/ducks'
import type { Configs } from '../types'
import _ from 'lodash'
import { getCarousel } from '../../redux/selectors'
import type { ControlVisibility } from '../AdEdit'

type OwnProps = {| storeId: string, configs: Configs, controlVisibility: ControlVisibility |}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const carousel = getCarousel(state, ownProps.storeId)
  return {
    errors: carousel.errors,
    hasAnyCards: carousel.cards.length > 0,
    cardControlVisibility: {
      description: ownProps.controlVisibility.tmCarousel || ownProps.controlVisibility.fbCarousel,
      vkLinkButton: ownProps.controlVisibility.vkCarousel,
      price: ownProps.controlVisibility.vkCarousel,
      oldPrice: ownProps.controlVisibility.vkCarousel
    }
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  return {
    onChange: (cards) => {
      dispatch(patch(ownProps.storeId, { cards }))
    },
    onAdd: () => {
      dispatch(add(ownProps.storeId))
    }
  }
}

const CarouselContainer = connect<Object, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(Carousel)

export default CarouselContainer
